import Link from "next/link";
import Image from "next/image";
import { getRelatedPosts } from "../posts";

/**
 * Displays related articles based on keyword overlap.
 * Improves internal cross-linking for SEO.
 */
export default function RelatedArticles({ slug, limit = 3 }) {
  const related = getRelatedPosts(slug, limit);

  if (related.length === 0) return null;

  return (
    <section
      style={{
        marginTop: 48,
        padding: "32px 0",
        borderTop: "1px solid #e4e9f2",
      }}
    >
      <h2
        style={{
          fontSize: 22,
          fontWeight: 700,
          marginBottom: 24,
          color: "#101828",
        }}
      >
        Related Articles
      </h2>
      <div
        style={{
          display: "grid",
          gridTemplateColumns: "repeat(auto-fill, minmax(260px, 1fr))",
          gap: 20,
        }}
      >
        {related.map((post) => (
          <Link
            key={post.slug}
            href={`/blog/${post.slug}`}
            style={{ textDecoration: "none", color: "inherit" }}
          >
            <article
              style={{
                border: "1px solid #e4e9f2",
                borderRadius: 14,
                overflow: "hidden",
                transition: "all 0.2s ease",
                background: "#fff",
              }}
              onMouseEnter={(e) => {
                e.currentTarget.style.transform = "translateY(-4px)";
                e.currentTarget.style.boxShadow =
                  "0 12px 24px rgba(130, 0, 244, 0.1)";
              }}
              onMouseLeave={(e) => {
                e.currentTarget.style.transform = "translateY(0)";
                e.currentTarget.style.boxShadow = "none";
              }}
            >
              <div
                style={{
                  position: "relative",
                  width: "100%",
                  height: 140,
                  background: "#f3f0ff",
                }}
              >
                <Image
                  src={post.image}
                  alt={post.title}
                  fill
                  sizes="(max-width: 768px) 100vw, 33vw"
                  style={{ objectFit: "cover" }}
                />
              </div>
              <div style={{ padding: "16px 18px" }}>
                <span
                  style={{
                    fontSize: 11,
                    fontWeight: 600,
                    color: "#6b00d4",
                    textTransform: "uppercase",
                    letterSpacing: "0.5px",
                  }}
                >
                  {post.category}
                </span>
                <h3
                  style={{
                    fontSize: 15,
                    fontWeight: 600,
                    color: "#101828",
                    marginTop: 6,
                    marginBottom: 8,
                    lineHeight: 1.4,
                    display: "-webkit-box",
                    WebkitLineClamp: 2,
                    WebkitBoxOrient: "vertical",
                    overflow: "hidden",
                  }}
                >
                  {post.title}
                </h3>
                <span
                  style={{
                    fontSize: 12,
                    color: "#475467",
                  }}
                >
                  {post.readingTime}
                </span>
              </div>
            </article>
          </Link>
        ))}
      </div>
    </section>
  );
}
